import {
  IListColumn,
  IListElement,
  isButtonCell,
} from 'app/services/api5-service/api.interface';
import { getButtonList } from 'components/form-button/form-button.utils';
import { IFormButtonUi } from 'components/form-button/model';

import { ISPFormState } from 'common/dynamic-form/model';
import { DocHelper } from 'utils/dochelper';

import { IListCellUi } from '../../list-cell/model';

/**
 * Get buttons local dto for cell from BE metadata
 *
 * @param element - list element
 * @param column - column metadata
 * @param state - dynamic form state
 */
function getListCellButtons(
  element: IListElement,
  column: IListColumn,
  state: ISPFormState,
): IFormButtonUi[] | undefined {
  const cell = element[column.$name];
  if (!isButtonCell(cell)) {
    return;
  }

  const buttons = DocHelper.getArrayWrapperValue(cell.button).filter(
    button => button.$hidden !== 'yes',
  );
  return getButtonList(state.docSubject.value, buttons, state.showHints).map(
    button => {
      if (button.key) {
        button.keyValue = element[button.key]?.$;
      }
      return button;
    },
  );
}

/**
 * Get cell button with specific data
 *
 * @param cell - FE cell base metadata
 * @param element - BE meta of list row
 * @param column - BE meta of list column
 * @param state - form state
 */
export function getButtonCellWithData(
  cell: IListCellUi,
  element: IListElement,
  column: IListColumn,
  state: ISPFormState,
): IListCellUi {
  const buttons = getListCellButtons(element, column, state);
  cell.buttons = buttons;
  // @WARN it shouldn't be zero! Safari case
  cell.width = '0.1px';
  cell.trackBy = buttons?.map(button => button.id).join('');
  return cell;
}
